export default "__VITE_PUBLIC_ASSET__a445bdc1__"